(() => {
  'use strict';
  const root = document.querySelector('[data-thermal-experience]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const cards = [...root.querySelectorAll('[data-camera]')];
  const filters = root.querySelector('[data-filter-controls]');
  if (filters) {
    filters.hidden = false;
    const count = filters.querySelector('[data-filter-count]');
    count.textContent = `${cards.length} cameras`;
    filters.addEventListener('click', event => {
      const button = event.target.closest('[data-filter]');
      if (!button) return;
      filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      cards.forEach(card => { card.hidden = button.dataset.filter !== 'all' && card.dataset.vendor !== button.dataset.filter; });
      count.textContent = `${cards.filter(card => !card.hidden).length} cameras`;
      window.ScrollTrigger?.refresh();
    });
  }
  const compare = root.querySelector('[data-comparison]');
  if (compare && cards.length > 1) {
    const selects = [...compare.querySelectorAll('select')];
    const render = index => {
      const card = cards[Number(selects[index].value)];
      const result = compare.querySelector(`[data-compare-result="${index}"]`);
      const photo = card.querySelector('img').cloneNode();
      const title = document.createElement('h3');
      title.textContent = card.dataset.name;
      const details = card.querySelector('dl').cloneNode(true);
      const role = document.createElement('div');
      const term = document.createElement('dt'); term.textContent = 'Role';
      const definition = document.createElement('dd'); definition.textContent = card.querySelector('.te-kicker').textContent;
      role.append(term, definition); details.prepend(role);
      const price = card.querySelector('.te-price').cloneNode(true);
      const availability = card.querySelector('.te-availability').cloneNode(true);
      const link = document.createElement('a');
      link.href = card.querySelector('.te-product-link').href;
      link.className = 'te-button'; link.textContent = 'View camera';
      result.replaceChildren(photo, title, details, price, availability, link);
    };
    selects.forEach((select, index) => {
      cards.forEach((card, cardIndex) => select.add(new Option(card.dataset.name, String(cardIndex))));
      select.value = String(index === 1 && root.dataset.brand === 'hub' ? Math.max(1, cards.findIndex(c => c.dataset.vendor === 'seek')) : index);
      select.addEventListener('change', () => render(index)); render(index);
    });
    compare.hidden = false;
  }
  root.addEventListener('submit', async event => {
    const form = event.target.closest('[data-te-cart]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    if (button.disabled) return;
    const status = form.querySelector('[role="status"]');
    const label = button.innerHTML;
    button.disabled = true; button.textContent = 'Adding...'; status.textContent = '';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {method:'POST', headers:{Accept:'application/json'}, body:new FormData(form)});
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'This item could not be added. Please check its product page.');
      status.append(document.createTextNode('Added to your cart. '));
      const cartLink = document.createElement('a'); cartLink.href = `${window.Shopify?.routes?.root || '/'}cart`; cartLink.textContent = 'View cart'; status.append(cartLink);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
    } catch (error) {
      status.textContent = error instanceof Error ? error.message : 'Could not confirm the cart update. Check your cart before trying again.';
    } finally {button.disabled = false; button.innerHTML = label;}
  });
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motionButton = root.querySelector('[data-motion-toggle]');
  let motionAllowed = !reduced.matches;
  let motionContext;
  let mediaContext;
  let generation = 0;
  const scriptLoads = new Map();
  function loadScript(url) {
    if (scriptLoads.has(url)) return scriptLoads.get(url);
    const promise = new Promise((resolve,reject) => {
      const script = document.createElement('script'); script.src=url;script.onload=resolve;script.onerror=()=>reject(new Error('Thermal motion could not load'));document.head.append(script);
    });
    scriptLoads.set(url,promise);return promise;
  }
  async function setMotion() {
    const version = ++generation;
    mediaContext?.revert(); mediaContext = null; motionContext?.revert(); motionContext = null;
    root.dataset.motion = motionAllowed ? 'on' : 'off';
    motionButton.textContent = motionAllowed ? 'Motion on' : 'Motion off';
    motionButton.setAttribute('aria-pressed', String(motionAllowed));
    if (!motionAllowed) {root.querySelectorAll('video').forEach(video=>video.pause());return;}
    try {
      if (!window.gsap) await loadScript(root.dataset.gsap);
      if (!window.ScrollTrigger) await loadScript(root.dataset.scrolltrigger);
      if (version !== generation || !motionAllowed || !root.isConnected) return;
      const gsap = window.gsap;
      gsap.registerPlugin(window.ScrollTrigger);
      motionContext = gsap.context(() => {
        gsap.from(root.querySelectorAll('.te-flir-headline, .te-hub-heading h1, .te-seek-hero h1'), {y:25,opacity:.3,duration:1.1,ease:'power3.out'});
      }, root);
      mediaContext = gsap.matchMedia();
      mediaContext.add('(min-width: 1000px)', () => {
        root.querySelectorAll('[data-hero-camera]').forEach(image => gsap.to(image,{y:75,scale:1.12,ease:'none',scrollTrigger:{trigger:image.closest('header'),start:'top top',end:'bottom top',scrub:1}}));
        const story=root.querySelector('[data-story]');
        if(story) {
          const sticky=story.querySelector('.te-story-sticky');
          gsap.to(story.querySelector('[data-story-camera]'),{rotation:8,scale:1.1,y:20,ease:'none',scrollTrigger:{trigger:story,start:'top 15%',end:'bottom 85%',scrub:1}});
          window.ScrollTrigger.create({trigger:story,start:'top 15%',end:()=>`+=${Math.max(0,story.offsetHeight-sticky.offsetHeight-100)}`,pin:sticky,pinSpacing:false,invalidateOnRefresh:true});
        }
        root.querySelectorAll('[data-family-camera], [data-scale-image]').forEach(image => gsap.fromTo(image,{scale:.9,y:30},{scale:1,y:-20,ease:'none',scrollTrigger:{trigger:image,start:'top bottom',end:'bottom 20%',scrub:1}}));
      });
      mediaContext.add('(max-width: 999px)', () => {
        root.querySelectorAll('[data-family-camera], [data-scale-image]').forEach(image => gsap.from(image,{y:24,scale:.96,duration:.8,ease:'power3.out',scrollTrigger:{trigger:image,start:'top 90%',once:true}}));
      });
      window.ScrollTrigger.refresh();
    } catch (error) {
      root.dataset.motion = 'unavailable'; motionButton.hidden = true;
      console.warn('Thermal motion unavailable; all shopping content remains accessible.', error);
    }
  }
  motionButton.hidden=false;
  motionButton.addEventListener('click',()=>{motionAllowed=!motionAllowed;setMotion();});
  reduced.addEventListener('change',()=>{motionAllowed=!reduced.matches;setMotion();});
  setMotion();
})();
